import React from "react";
import { Button } from "../Common/Buttons/Button";

export const ExitButton = ({
  handleExitClick,
}: {
  handleExitClick: () => void;
}) => (
  <Button
    onPress={handleExitClick}
    variant="secondary"
    icon="x"
    aria-label="Exit"
  />
);
